<template>
  <div class="calendar-wrapper">

    <div class="calendar-list bg_fff">

      <div class="calendar-list-header">
        <h2>我的约面</h2>
        <span v-if="isShowToday" @click="handleToday()">今天</span>
      </div>

      <div ref="calendarListContent" class="calendar-list-content" v-loading="isLoading">

        <template v-if="isHaveData">
          <template v-for="(itemList, indexList) in calendarList">

            <div :ref="`listItem&${itemList.interview_date}`" class="list-item" v-if="itemList.list.length" :key="indexList">
              <div class="list-item-date" :class="itemList.isToday && 'list-item-today'">
                {{ `${moment(itemList.interview_date).format('YYYY.MM.DD')}${itemList.isToday ? '（今天）' : ''}` }}
              </div>

              <template v-for="(itemCard, indexCard) in itemList.list">
                <div class="list-item-card" :key="indexCard" @click="toChat(itemCard)">
                  <div class="card-state" v-if="itemCard.appoint_type == 2" :class="checkStateClass(itemCard)">{{checkState(itemCard)}}</div>
                  <div class="user-info">
                    <img :src="!!itemCard.cv_account_avatar ? itemCard.cv_account_avatar : headImgList[indexCard % 4]" alt="">
                    <span>{{ itemCard.cv_account_name || '超级简历用户' }}</span>
                    <i class="iconfont iconGroup3 item-card-delete" @click.stop="deleteSchedule(itemCard)"></i>
                  </div>
                  <div class="list-info">
                    <i class="iconfont iconzhiwei1"></i>
                    <span>{{itemCard.job_title}}</span>
                  </div>
                  <div class="list-info">
                    <i class="iconfont iconshijian1"></i>
                    <span v-if="itemCard.appoint_type == 2">
                      {{myInterviewTime(itemCard)}}
                    </span>
                    <span v-else>
                      {{itemCard.interview_date}} {{itemCard.interview_time === 1 ? '上午' : '下午'}}
                    </span>
                  </div>
                  <div class="list-info">
                    <i class="iconfont iconshoujihao"></i>
                    <span>{{itemCard.phone}}</span>
                  </div>
                  <!-- <span>{{ itemCard.job_title }}</span>
                  <span>{{ `${itemCard.cv_account_name || '超级简历用户'}·${itemCard.interview_time === 1 ? '上午' : '下午'}` }}</span> -->
                </div>
              </template>

            </div>

          </template>
        </template>

        <template v-if="!isHaveData">
          <div class="calendar-not-data">
            <img src="https://files.wondercv.com/b-pc-calendar/not-data.png" alt="not data">
            <template v-if="onlineJobLength">
              <p>看看更多优质人才简历吧～</p>
              <div @click="$router.push({path:'/talent/recommend'})">去看简历</div>
            </template>
            <template v-else>
              <p>快去发布一个职位吧～</p>
              <div @click="$router.push({path:'/talent/jobedit/create'})">发布职位</div>
            </template>
          </div>
        </template>

      </div>

    </div>

    <div class="calendar-table bg_fff">

      <div class="calendar-table-header">
        <div class="table-button-left table-button" @click="toggleCalendar(-1)">
          <i class="iconfont iconxuanxiang-shouqi"></i>
        </div>
        <span class="table-header-date">{{ `${nowYear}年${nowMonth}月` }}</span>
        <div class="table-button-right table-button" @click="toggleCalendar(1)">
          <i class="iconfont iconxuanxiang-shouqi"></i>
        </div>
        <div class="calendar-header-right">
          <el-tooltip effect="dark" content="在沟通中由你发起的“约面试”" placement="bottom-end">
            <div class="my-interview">
              <div></div>
              <div></div>
              <span>我的约面</span>
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="通过直面职位发起的面试" placement="bottom-start">
            <div class="my-interview direct-interview">
              <div></div>
              <div></div>
              <span>直面约面</span>
           </div>
          </el-tooltip>
        </div>
      </div>

      <div class="calendar-table-content">
        <table>
          <thead>
            <td v-for="(itemHeader, indexHeader) in weekMap" :key="itemHeader+'&'+indexHeader">
              {{ itemHeader }}
            </td>
          </thead>
          <tbody ref="tbodyDom">
            <template v-for="(itemDate, indexDate) in calendarList">

              <td v-if="!itemDate.outside" class="calendar-item" :key="itemDate.interview_date+'&'+indexDate" @click="positionToCard(itemDate)">
                <span class="calendar-item-date" :class="itemDate.isToday && 'calendar-item-today'">{{ moment(itemDate.interview_date).format('DD') }}</span>

                <!-- 可展示数等于1 总数正好为1时 -->
                <template v-if="showCount === 1 && itemDate.list.length === showCount">
                  <p class="calendar-item-person" :class="{'calendar-item-my' : itemDate.list[0].appoint_type == 2}">{{ `${itemDate.list[0].cv_account_name || '超级简历用户'}-${itemDate.list[0].job_title}` }}</p>
                </template>

                <!-- 可展示数等于1 总数大于1时 -->
                <template v-if="showCount === 1 && itemDate.list.length > showCount">
                  <p class="calendar-item-more">{{ `有 ${itemDate.list.length} 个日程` }}</p>
                </template>

                <!-- 可展示数大于1 总数小于或者等于能展示的数量，则直接展示 -->
                <template v-if="showCount > 1 && itemDate.list.length <= showCount && itemDate.list.length">
                  <p class="calendar-item-person" :class="{'calendar-item-my' : item.appoint_type == 2}" v-for="(item, index) in itemDate.list" :key="index">{{ `${item.cv_account_name || '超级简历用户'}-${item.job_title}` }}</p>
                </template>

                <!-- 可展示数大于1 总数大于可展示数量，就展示 showCount - 1 个，同时展示剩下日程数 itemDate.list.length - (showCount-1) -->
                <template v-if="showCount > 1 && itemDate.list.length > showCount">
                  <p class="calendar-item-person" :class="{'calendar-item-my' : item.appoint_type == 2}" v-for="(item, index) in itemDate.list.slice(0, showCount - 1)" :key="index">{{ `${item.cv_account_name || '超级简历用户'}-${item.job_title}` }}</p>
                  <p class="calendar-item-more">{{ `还有 ${itemDate.list.length - (showCount - 1)} 个日程` }}</p>
                </template>

              </td>

              <td v-else class="calendar-item outside" :key="itemDate.interview_date+'&'+indexDate">
                <span class="calendar-item-date">{{ moment(itemDate.interview_date).format('DD') }}</span>
              </td>

            </template>
          </tbody>
        </table>
      </div>

    </div>

    <!-- 弹窗 -->
    <tips-block
      v-if="tipsVisible"
      :tipsTitle="tipsOptions.tipsTitle"
      :tipsText="tipsOptions.tipsText"
      @confirmFunc="tipsConfirm"
      @cancelFunc="tipsCancel"
    />
  </div>
</template>

<script>
import moment from 'moment'
import actions from '@/actions/index'
import { get_tUser } from '@/utils/utils'
import { headImgList } from '@/utils/static'
import TipsBlock from '@/components/block/TipsBlock'
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      moment,
      headImgList: headImgList.round, // 默认头像
      userJWT: null, // 用户信息
      calendarList: [], // 一个月的日历数据
      nowIndex: 0, // 当前日历指针 可能的值：-1前一个月 0当前月 1下一个月
      nowYear: null, // 当前年
      nowMonth: null, // 当前月
      nowDeleteData: null, // 要删除的人数据
      tipsVisible: false, // 控制弹窗显示和隐藏
      isLoading: true, // 是否正在请求
      isHaveData: true, // 是否有数据
      isShowToday: false, // 是否显示今天
      showCount: 0, // 可展示数，因为设置了最小高度，所以可展示数的最小值为1
      onlineJobLength: 0, // 在线职位数
      weekMap: ['周日', '周一', '周二','周三', '周四', '周五', '周六'],
      tipsOptions: {
        tipsTitle: '取消面试',
        tipsText: '是否取消与候选人的面试安排？'
      }
    }
  },
  components: {
    TipsBlock
  },
  created () {
    this.init()
  },
  mounted () {
    this.listenerClientHeight()
    // 监听视图变化
    window.addEventListener('resize', this.listenerClientHeight)
  },
  beforeDestroy () {
    // 销毁
    window.removeEventListener('resize', this.listenerClientHeight)
  },
  methods: {
    ...mapMutations('im',['updateSmallChatOpenId']),
    // 初始化
    init () {
      // 获取 hr token
      this.userJWT = get_tUser()
      // 初始化日历数据
      this.createData()
      // 获取在线职位数
      this.getOnlineJob()
    },
    // 创建数据
    createData () {
      // 获取这个月有多少天
      let nowYear = null
      let nowMonth = null
      if (this.nowIndex === 0) {
        nowYear = this.moment().format('YYYY')
        nowMonth = this.moment().format('MM')
      }else if (this.nowIndex === -1) {
        nowYear = this.moment().subtract(1, 'months').format('YYYY')
        nowMonth = this.moment().subtract(1, 'months').format('MM')
      } else if (this.nowIndex === 1) {
        nowYear = this.moment().add(1, 'months').format('YYYY')
        nowMonth = this.moment().add(1, 'months').format('MM')
      }
      let nowDays = new Date(Number(nowYear), Number(nowMonth), 0).getDate() // 这个月有多少天
      let firstDayDate = `${nowYear}-${nowMonth}-01` // 这个月1号的日期
      this.nowYear = nowYear
      this.nowMonth = nowMonth
      // 创建这个月的数据
      let dateArr = []
      for (let i = 0; i < nowDays; i++) {
        let dateValue = this.moment(firstDayDate).add(i, 'd').format('YYYY-MM-DD')
        let obj = {
          interview_date: dateValue,
          list: [],
          isToday: dateValue === this.moment().format('YYYY-MM-DD')
        }
        dateArr.push(obj)
      }
      // 获取这个月1号是星期几
      let firstIndex = this.moment(firstDayDate).day() // firstIndex返回几，就在数据前 加几天
      // 在前加天数
      let firstObjArr = []
      for (let f = 1; f <= firstIndex; f ++) {
        let firstDateValue = this.moment(firstDayDate).subtract(f, 'd').format('YYYY-MM-DD')
        let firstObj = {
          outside: true, // 唯一标识，这是范围之外的天数
          interview_date: firstDateValue,
          list: [],
          isToday: false
        }
        firstObjArr.unshift(firstObj)
      }
      dateArr = [...firstObjArr, ...dateArr]
      // 获取应该向后加几天的天数（一共展示42天）
      let lastIndex = 42 - dateArr.length
      // 在后加天数
      let lastObjArr = []
      for (let l = 1; l <= lastIndex; l++) {
        let lastDateValue = this.moment(dateArr[dateArr.length - 1].interview_date).add(l, 'd').format('YYYY-MM-DD')
        let lastObj = {
          outside: true, // 唯一标识，这是范围之外的天数
          interview_date: lastDateValue,
          list: [],
          isToday: false
        }
        lastObjArr.push(lastObj)
      }
      dateArr = [...dateArr, ...lastObjArr]
      // 赋值
      this.calendarList = dateArr
      // console.log('日历数据======>', this.calendarList )
      // 请求接口，拿到数据并且进行混合
      this.getData(`${nowYear}-${nowMonth}-01`)
    },
    // 获取在线职位数
    async getOnlineJob () {
      try {
        let res = await actions.resume_permissions.recruitment()
        if (res.code === 1000) {
          this.onlineJobLength = res.data.recruit_infos.length
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取数据
    async getData (monthValue) {
      try {
        let params = {
          hr_account_token: this.userJWT.h_t,
          query: {
            month: monthValue
          }
        }
        let res = await actions.interview.get_interview_calendar(params)
        if (res.code === 1000) {
          if (res.data.length) {
            this.isShowToday = true
            // 有数据，才混合
            this.formatData(res.data)
          } else {
            this.isHaveData = false
          }
          this.isLoading = false
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 混合数据结构
    formatData (data) {
      // 排序 先上午 再下午 先我的约面 再直面
      let amArrMy = []
      let amArrDirect = []
      let pmArrMy = []
      let pmArrMyDirect = []
      amArrMy = data.filter(item => {
        return item.interview_time == 1 && item.appoint_type == 2
      })
      amArrDirect = data.filter(item => {
        return item.interview_time == 1 && item.appoint_type == 1
      })
      pmArrMy = data.filter(item => {
        return item.interview_time == 2 && item.appoint_type == 2
      })
      pmArrMyDirect = data.filter(item => {
        return item.interview_time == 2 && item.appoint_type == 1
      })
      data = [...amArrMy, ...amArrDirect, ...pmArrMy, ...pmArrMyDirect]
      // 将数据插入到 calendarList 的每一天中
      data.forEach(itemData => {
        this.calendarList.forEach((itemCalendar, indexCalendar) => {
          // 找到相同日期，然后将人的信息添加进去，并且是本月的才添加
          if (itemData.interview_date === itemCalendar.interview_date && !itemCalendar.outside) {
            itemCalendar.list.push(itemData)
            // this.calendarList[indexCalendar].list.push(itemData)
          }
        })
      })
      // console.log('混合后的数据======>', this.calendarList)
    },
    // 切换日历
    toggleCalendar (type) {
      if (this.nowIndex === type) return
      // 重置
      this.isLoading = true
      this.isHaveData = true
      this.isShowToday = false
      this.nowIndex += type
      this.createData()
    },
    // 定位左侧卡片
    positionToCard (data) {
      if (!data.list.length) return false
      // 获取滚动距离
      let scrollY = this.$refs[`listItem&${data.interview_date}`][0].offsetTop
      // 赋值
      this.$refs.calendarListContent.scrollTop = scrollY
    },
    handleToday () {
      let today = this.moment().format('YYYY-MM-DD')
      if (!this.$refs[`listItem&${today}`]) return
      let scrollY = this.$refs[`listItem&${today}`][0].offsetTop
      this.$refs.calendarListContent.scrollTop = scrollY
    },
    // 跳转到IM详情页
    toChat (data) {
      this.updateSmallChatOpenId(data.cv_account_token)
      // window.open(`${window.location.origin}/talent/chat?chat_id=${data.cv_account_token}`)
    },
    // 控制tips显示和隐藏
    showTips (flag) {
      this.tipsVisible = flag
    },
    // 删除日程
    deleteSchedule (data) {
      // 保存要删除的人数据
      this.nowDeleteData = JSON.parse(JSON.stringify(data))
      // 显示弹窗
      this.showTips(true)
    },
    async tipsConfirm () {
      try {
        let res = await actions.interview.delete_interview_appointment(this.nowDeleteData.id)
        if (res.code === 1000) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          // 把删除的从数据中剪切掉
          this.deleteData()
          this.showTips(false)
        }
      } catch (e) {
        console.log(e)
      }
    },
    tipsCancel () {
      // 清理要删除的人数据
      this.nowDeleteData = null
      // 关闭弹窗
      this.showTips(false)
    },
    // 把删除的从数据中剪切掉
    deleteData () {
      this.calendarList.forEach(itemCalendar => {
        // 找到那一天的数据
        if (itemCalendar.interview_date === this.nowDeleteData.interview_date) {
          itemCalendar.list.forEach((itemList, indexList) => {
            // 找到同一人
            if(itemList.id = this.nowDeleteData.id) {
              itemCalendar.list.splice(indexList, 1)
            }
          })
        }
      })
    },
    // 监听视图的变化
    listenerClientHeight () {
      // tbody 的高度
      let tbodyHeight = this.$refs.tbodyDom.clientHeight
      // td 的高度
      let tdHeight = Math.floor(tbodyHeight / 6)
      // td 减去日期后内容区的高度
      let tdContentHeight = tdHeight - 30
      // 可以展示的日程数
      let count = Math.floor(tdContentHeight / 22)
      this.showCount = count
    },
    // 检查状态(类名)
    checkStateClass(data) {
      let stateStr = this.checkState(data);
      switch (stateStr) {
        case '待确认':
          return 'card-state-no-sure';
        case '已确认':
          return 'card-state-confirm';
        case '已完成':
          return 'card-state-complete';
        case '被拒绝':
          return 'card-state-reject';
        case '已过期':
          return 'card-state-past';
      }
    },
    // 检查状态
    checkState(data) {
      let interview_datetime = this.moment.utc(data.interview_datetime).format('YYYY-MM-DD HH:mm')
      let nowTime = this.moment().format('YYYY-MM-DD HH:mm')
      let isOverTime = new Date(nowTime).getTime() > new Date(interview_datetime).getTime()
      switch (data.c_match) {
        case 1:
          return isOverTime ? '已过期' : '待确认' ;
        case 2:
          return '被拒绝';
        case 3: 
          return isOverTime ? '已完成' : '已确认' ;    
      }
    },
    myInterviewTime(itemCard) {
      if(itemCard.interview_date) {
        let date = this.moment.utc(itemCard.interview_datetime)
        return date.format('MM.DD') + (itemCard.interview_time == 1 ? '  (上午)  ' : '  (下午)  ') + date.format('HH:mm')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./Index.scss";
</style>
